import { memo } from 'react';

import { useDevice } from '../../store/devices/useDevices.ts';

import { Indicator } from './Indicator';
import { DeviceTileStatic } from './DeviceTileStatic';

export const DeviceStatic = memo(function Device({ deviceId, tileSize }) {
  const { device } = useDevice({ deviceId });

  const deviceName = device?.name.replace(/\s/g, ' ');

  return (
    <DeviceTileStatic
      name={deviceName}
      deviceId={deviceId}
      device={device}
      iconObj={device?.iconObj}
      iconOverride={device?.iconOverride}
      indicator={<Indicator device={device} tileSize={tileSize} />}
      tileSize={tileSize}
    />
  );
});
